module.exports = __webpack_public_path__ + "static/media/en.b398ba42.svg";